import React from 'react';

const CancelIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <rect width="24" height="24" fill="white" fillOpacity="0.01" />
      <path d="M6.35341 16.69L16.6882 6.35156M6.35156 6.35341L16.69 16.6882" stroke="#000" />
    </svg>
  );
};

export default CancelIcon;
